var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkCircledOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "#FF5F14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2664 7.57689C16.5001 7.72402 16.5703 8.03273 16.4231 8.26641L11.3861 16.2664C11.3013 16.401 11.1575 16.4873 10.9989 16.4987C10.8402 16.5101 10.6855 16.4453 10.5824 16.3242L7.61939 12.846C7.44032 12.6358 7.46557 12.3202 7.67578 12.1411C7.88599 11.9621 8.20156 11.9873 8.38063 12.1975L10.9024 15.1578L15.5769 7.7336C15.724 7.49992 16.0327 7.42976 16.2664 7.57689Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircledOrange);
export default __webpack_public_path__ + "static/media/CheckmarkCircledOrange.cfb5245c26a11ee00a7c43ad4f642b56.svg";
export { ForwardRef as ReactComponent };